"use client"

// components/Header.js
import { useEffect } from 'react';
import { usePathname } from 'next/navigation'; // Import the useRouter hook
import Image from 'next/image';

import '@fortawesome/fontawesome-free/css/all.min.css';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import '../styles/animate.css';

const Header = () => {

  const pathname = usePathname(); // Get the current path

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar-area');
      if (window.scrollY < 20) {
        navbar.classList.remove('sticky');
      } else {
        navbar.classList.add('sticky');
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>

      {/* Head component for meta tags, title, and CSS links */}
        <header className="header-area">
            <div className="navbar-area"> 
                <div className="container">
                    <nav className="navbar navbar-expand-lg navbar-light">
                        <div className="container-fluid">
                          <a className="navbar-brand" href="/">
                            <Image className="image" alt="logo" src="/header/logo/stlogo.png" width={320} height={120}/>
                          </a>
                          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span className="navbar-toggler-icon"></span>
                          </button>
                          <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul className="navbar-nav ms-auto">
                              <li className="nav-item">
                                <a className="nav-link active" aria-current="page" href="/">Home</a>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                  Our Services
                                </a>
                                <ul className="dropdown-menu">
                                  <li><a className="dropdown-item" href="/">Web App Development </a></li>
                                  <li><a className="dropdown-item" href="/">Digital Marketing Solutions</a></li>
                                  <li><a className="dropdown-item" href="/">Content Writing</a></li>
                                  <li><a className="dropdown-item" href="/">Content Marketing</a></li>
                                  <li><a className="dropdown-item" href="/">Mobile App Development</a></li>
                                  <li><a className="dropdown-item" href="/">Hotel App Development (Ready-made)</a></li>
                                  <li><a className="dropdown-item" href="/">Taxi App Development (Ready-made)</a></li>
                                  <li><a className="dropdown-item" href="/">E-Commerse Development (Ready-made)</a></li>
                                  <li><a className="dropdown-item" href="/">Blockchain Development</a></li>
                                  <li><a className="dropdown-item" href="/">Fintech Solutions</a></li>
                                  <li><a className="dropdown-item" href="/">DeFi App Development</a></li>
                                  <li><a className="dropdown-item" href="/">DApp Development</a></li>
                                  <li><a className="dropdown-item" href="/">Web3 Solutions</a></li>
                                  <li><a className="dropdown-item" href="/">Cryptocurrency</a></li>
                                  <li><a className="dropdown-item" href="/">Cryptocurrency Exchange Development</a></li>
                                  <li><a className="dropdown-item" href="/">Smart Contract Development</a></li>
                                  <li><a className="dropdown-item" href="/">Wallet Development</a></li>
                                  <li><a className="dropdown-item" href="/">Token/ICO/STO</a></li>
                                  <li><a className="dropdown-item" href="/">NFT</a></li>
                                  <li><a className="dropdown-item" href="/">Trading Bot Developement</a></li>
                                  <li><a className="dropdown-item" href="/">AI Development</a></li>
                                  <li><a className="dropdown-item" href="/">AI Token Development</a></li>
                                  <li><a className="dropdown-item" href="/">Metaverse</a></li>
                                  <li><a className="dropdown-item" href="/">Game Development</a></li>
                                </ul>
                              </li>
                              <li className="nav-item">
                                <a className="nav-link" href="/about-us">About Us</a>
                            </li>

                            {/* Conditionally render the FAQs link */}
                                {pathname === '/' && (
                                  <li className="nav-item">
                                    <a
                                      className="nav-link"
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault(); // Prevents URL change
                                        document.getElementById("faqs").scrollIntoView({ behavior: "smooth", block: "start" });
                                      }}
                                    >
                                      FAQs
                                    </a>
                                  </li>
                                )}
                            
                              <li className="nav-item">
                                <a className="nav-link" href="/contact-us">Contact Us</a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </nav>
                </div>
            </div>
        </header>
    </>
  );
};

export default Header;
